import React, {Component} from "react";
import {ControlPanelService} from "../../../service/controlPanel/ControlPanelService";
import TransactionalLog from "./TransactionalLogView";
import {CONTROL_PANEL_ROUTE} from "../../../utils/constants/RoutesConstants";

export default class TransactionalLogContainer extends Component {
    constructor(props) {
        super(props);

        this.controlPanelService = new ControlPanelService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.getTransactionalLog = this.getTransactionalLog.bind(this);

        this.state = {
            isLoading: true,
            transactionLogList: this.getTransactionalLog(),
        }
    };

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton() {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
        });
    }

    getTransactionalLog() {
        this.loading(true);
        this.controlPanelService.getTransactionalLog(
            this.props.location.state.folio
        ).then(response => {
                this.loading(false);
                this.setState({
                    transactionLogList: response
                });
            }
        );
    }

    render() {
        return <TransactionalLog
            isLoading={this.state.isLoading}
            handleReturnButton={this.handleReturnButton}
            transactionLogList={this.state.transactionLogList}
            loanId={this.props.location.state.folio}
        />

    }
};